import { Pipe, PipeTransform } from '@angular/core';
import { QRCategoryItemModel } from '@cue/api';

@Pipe({
  name: 'categoryListResourcesOnly',
  standalone: true,
})
export class CategoryListResourcesOnlyPipe implements PipeTransform {
  transform(listData: QRCategoryItemModel[]): QRCategoryItemModel[] {
    if (listData) {
      return listData.filter((x) => x.resourceTypeId);
    }
    return [];
  }
}
